import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Button,
    ClickAwayListener,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Tooltip,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        dropdownBg: {
            minWidth: '30px',
            padding: '0px',
            color: 'inherit',
        },
    }),
);

interface IUiDropdownButtonProps {
    tooltip?: string;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    label: string;
    menuItems: IUiDropdownButtonMenuItemProps[];
    width?: number;
}

interface IUiDropdownButtonMenuItemProps {
    label: string;
    onClick?: (event: React.MouseEvent<HTMLLIElement>) => void;
}

export const UiDropdownButton: React.FC<IUiDropdownButtonProps> = ({
    tooltip,
    disabled,
    onClick,
    label,
    menuItems,
    width = 140,
}) => {
    const [ menuAnchorEl, setMenuAnchorEl ] = React.useState<null | HTMLElement>(null);

    return (
        <>
            <Tooltip
                arrow
                title={tooltip ?? ''}>
                <span>
                    <Button
                        disabled={disabled}
                        onClick={
                            onClick ?? (event => {
                                event.stopPropagation();
                                setMenuAnchorEl(event.currentTarget);
                            })
                        }
                        variant="contained"
                        data-testid="dropdown-btn-primary-action-button"
                        data-cy="dropdown-btn-primary-action-button"
                        endIcon={<KeyboardArrowDownIcon />}
                    >
                        {label}
                    </Button>
                </span>
            </Tooltip>
            <>
                {/* translate prop is required for Popper */}
                <Popper
                    open={!!menuAnchorEl}
                    anchorEl={menuAnchorEl}
                    placement="bottom-end"
                    translate={undefined}>
                    <ClickAwayListener onClickAway={() => setMenuAnchorEl(null)}>
                        <Paper>
                            <MenuList id="split-button-menu">
                                {menuItems.map((item, index) => (
                                    <MenuItem
                                        key={index}
                                        data-testid={`dropdown-btn-menu-item-${index}`}
                                        data-cy={`dropdown-btn-menu-item-${index}`}
                                        onClick={event => {
                                            setMenuAnchorEl(null);
                                            item.onClick?.(event);
                                        }}
                                    >
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Paper>
                    </ClickAwayListener>
                </Popper>
            </>
        </>
    );
};
